// Docs de `app_releases` (id = nombre del repo) con el puente de impresión de cada plataforma.
export const PRINTER_APPS = [
  { id: 'printer-bridge-windows', platform: 'windows', label: 'Windows' },
  { id: 'printer-bridge-android', platform: 'android', label: 'Android' },
];

export const PRINTER_APP_IDS = PRINTER_APPS.map((app) => app.id);

export const getCurrentPlatform = () => {
  const userAgent = navigator.userAgent || '';
  if (/android/i.test(userAgent)) return 'android';
  if (/windows/i.test(userAgent)) return 'windows';
  return null;
};

// Las notas vienen del release de GitHub; se quita la línea "**Full Changelog**: <link>" que agrega GitHub.
export const cleanNotes = (notes) => (notes || '').split('\n').filter((line) => !/full changelog/i.test(line)).join('\n').trim();

export const formatSize = (bytes) => {
  if (!bytes) return null;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

// stable.url es un link de descarga directa de Storage (sin login); en Android el sistema pide permiso para instalar.
export const downloadPrinterApp = (stable) => {
  window.location.href = stable.url;
};
